<mulo-prologue class="position-relative">
    <esp-research-unit-header [unitCode]="unitCode" activeEntity="homepage"></esp-research-unit-header>
</mulo-prologue>
<esp-research-unit-nav [tabPanel]="tabPanel" [unitCode]="unitCode" activeEntity="homepage"></esp-research-unit-nav>
<mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
@if (images?.length > 0) {
    <img [alt]="images?.[0]?.note" [src]="images[0]?.viewUrl" class="banner-img" />
}
<mulo-centered-block-layout class="description-section">
    @if (descriptions?.length > 0) {
        <mulo-expandable
            [collapseLabel]="'research.general.showLess' | translate"
            [expandLabel]="'research.general.showMore' | translate"
            [ratio]="9"
            class="margin-bottom-md rich-text-reset"
        >
            <div [innerHTML]="descriptions[0]?.value | translateObject | htmlTrust"></div>
        </mulo-expandable>
    }
    @if (links?.length > 0) {
        <div class="links">
            @for (link of links; track link.url) {
                <a [href]="link.url">{{ link.displayName || link.url }}</a>
                @if (!$last) {
                    <mulo-separator></mulo-separator>
                }
            }
        </div>
    }
</mulo-centered-block-layout>
@for (section of sections; track section.code) {
    @switch (section.code) {
        @case ('unitHomepage.collections') {
            <esp-research-unit-collections [unitCode]="unitCode"></esp-research-unit-collections>
        }
        @case ('unitHomepage.deptInNumbers') {
            <esp-research-unit-metrics [unitCode]="unitCode"></esp-research-unit-metrics>
        }
    }
}
